import { PageLayout } from '../components/Layout/PageLayout';
import { FractionGame } from '../components/FractionGame/FractionGame';
import { FractionHero } from '../components/FractionGame/FractionHero';

export function FractionsPage() {
  return (
    <PageLayout
      hero={<FractionHero />}
      game={<FractionGame />}
    />
  );
}